import { ListingType } from '@thurstech/commons/dist/entity/listing';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { matchPath, useLocation, useNavigate, useParams } from 'react-router-dom';

import AddProducts from './ticketBooking/AddProducts';
import AddVenue from './ticketBooking/AddVenue';
import AddTimeProducts from './timeBooking/AddTimeProduct';
import TableBooking from './timeBooking/TabelBooking';
import Button from '../../components/button/Button';
import InputSelect from '../../components/input/InputSelect';
import Loading from '../../components/loading/Loading';
import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { getListingThunk, getVenueThunk } from '../../redux/reducer/listingSlice';

type BusinessTypeSelectFormData = {
  listingType: ListingType;
};
const BusinessTypeSelect: React.FC = () => {
  const navigate = useNavigate();
  const { register, handleSubmit, watch, reset } = useForm<BusinessTypeSelectFormData>();
  const [movePage, setMovePage] = useState(false);
  const location = useLocation();

  const onSubmit = (_: BusinessTypeSelectFormData) => {
    setMovePage(true);
  };

  const { listingId, venueId } = useParams();

  const listing = useAppSelector(state => state.listing.listingMap[listingId ?? '']);
  const venue = useAppSelector(state => state.listing.venueMap[venueId ?? '']);
  const isLoading = useAppSelector(state => state.listing.isLoading);
  const error = useAppSelector(state => state.listing.error);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (listingId && !listing) {
      dispatch(getListingThunk(listingId)).then(() => {
        setMovePage(false);
        reset();
      });
    }
  }, [listingId]);

  useEffect(() => {
    if (venueId && !venue) {
      dispatch(getVenueThunk({ listingId: listingId!, venueId }));
    }
  }, [venueId]);

  if (listingId) {
    if (isLoading[getListingThunk.pending.toString()] || isLoading[getVenueThunk.pending.toString()]) {
      return <Loading />;
    } else if (error[getListingThunk.pending.toString()] || error[getVenueThunk.pending.toString()]) {
      navigate('/not-found');
      return <div />;
    }
  }

  // need || here because dfault value is ''
  const listingType = watch('listingType') || listing?.listingType;

  if (movePage || listing) {
    if (listingType === ListingType.SPORTS) {
      return <AddTimeProducts />;
    } else if (listingType === ListingType.RESTAURANT) {
      return <TableBooking />;
    } else {
      const match = matchPath('/product/:listingId/venue/:venueId?', location.pathname);
      return match ? <AddVenue /> : <AddProducts />;
    }
  }

  return (
    <div className=" bg-white pl-4 pt-2 font-medium pb-6 w-10/12">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Add Product</h1>
      </div>
      <form className="w-[418px] h-[40px]" onSubmit={handleSubmit(onSubmit)}>
        <InputSelect
          label="Type of Business"
          placeholder="Select type of business from list"
          name="listingType"
          required
          options={[
            { id: ListingType.EVENT_AND_WORKSHOP, value: 'Events and Workshops' },
            { id: ListingType.SPORTS, value: 'Sports Court Bookings' },
            { id: ListingType.RESTAURANT, value: 'Restaurant Table Bookings' }
          ]}
          register={register}
        />

        <Button label="Next" className="bg-emerald-400 text-white px-12 py-2 rounded" />
      </form>
    </div>
  );
};

export default BusinessTypeSelect;
